module.exports = __webpack_public_path__ + "assets/3@2x.363a1683.jpg";